import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";
import {
  setAnalyticsUserId,
  trackPageView,
  trackStandardPageView,
} from "@/client/utils/analytics";

const PAGE_MAP: { pattern: RegExp; userType: string; pageName: string }[] = [
  { pattern: /^\/$/, userType: "youth", pageName: "viewBuilder" },
  { pattern: /^\/auth\/login$/, userType: "youth", pageName: "viewLogin" },
  { pattern: /^\/auth\/register$/, userType: "youth", pageName: "viewRegister" },
  { pattern: /^\/auth\/forgot-password$/, userType: "youth", pageName: "viewForgot" },
  { pattern: /^\/auth\/reset-password$/, userType: "youth", pageName: "viewReset" },
  { pattern: /^\/auth\/verify-otp$/, userType: "youth", pageName: "viewVerifyOtp" },
  { pattern: /^\/auth\/backup-otp$/, userType: "youth", pageName: "viewBackupOtp" },
  { pattern: /^\/auth\/verify-email$/, userType: "youth", pageName: "viewVerifyEmail" },
  { pattern: /^\/dashboard\/resumes$/, userType: "youth", pageName: "viewResumes" },
  { pattern: /^\/dashboard\/settings$/, userType: "youth", pageName: "viewSettings" },
  { pattern: /^\/builder\/[^/]+$/, userType: "youth", pageName: "viewBuilderId" },
  { pattern: /^\/[^/]+\/[^/]+$/, userType: "youth", pageName: "viewPublic" },
];

export const PageViewTracker = () => {
  const { pathname } = useLocation();
  const userId = useAuthStore((state) => state.user?.id);

  useEffect(() => {
    const path = pathname.replace(/\/+$/, "") || "/";
    trackStandardPageView(path);
    const match = PAGE_MAP.find(({ pattern }) => pattern.test(path));
    if (match) {
      trackPageView({
        userType: match.userType,
        pageName: match.pageName,
        userId,
      });
    }
  }, [pathname, userId]);

  useEffect(() => {
    setAnalyticsUserId(userId);
  }, [userId]);

  return null;
};
